<template>
  <div class="profilContainer">
    <Header
      name="Mein Verkehrsservice"
      v-if="activeProfilOption !== 'NeueRoute' && activeProfilOption !== 'ServiceAnmelden' && activeProfilOption !== 'ServiceErstellen'"
    />
    <div class="profilContent">
      <div class="profilOptionContainer" v-if="!activeProfilOption" style="position:relative">
        <!--
            ######################
            Kartenansicht
            ######################
        -->
        <MeineKarten @closeSidebar="closeSidebar"/>

        <!--
            ######################
            Routen
            ######################
        -->
        <MeineStrecken
          @neueRouteAnlegen="setActiveProfilOption('NeueRoute')"
          @closeSidebar="closeSidebar"
        />

        <!--
            ######################
            PUSH Einstellungen
            ######################
        -->
        <PushSettings/>

        <!--
            ######################
            MeinService Einstellungen
            ######################
        -->
        <!--
              ########
              Service erstellen / anmelden
              ########
        -->
        <hr style="margin:47px 0;">
        <!-- Meinen Service speichern -->
        <div
          v-if="!userToken && checkIfErstellen()"
          class="displayflex padding10 cursor-pointer marginbottom20 borderBlue borderRadius30 margin20_0 borderStyleSolid borderWidth1"
          style="justify-content:space-between"
          @click="setActiveProfilOption('ServiceErstellen')"
        >
          <div class="displayflex">
            <SVGIcon name="user_on_kreis" size="little"/>
            <div class="colorBlue fontWeight600 selfAlignCenter marginleft15">Profil speichern</div>
          </div>
          <!-- @click.native="tooltipOpen = true" -->

          <div
            @click.stop
            v-if="tooltipOpen"
            class="backgroundGrey padding10 borderRadius10"
            style="position:absolute"
          >
            <div class="displayflex flexbetween">
              <SVGIcon name="id_transfer" size="big" style="width:100px"/>
              <SVGIcon
                name="close"
                size="small"
                class="cursor-pointer"
                @click.native="tooltipOpen = false"
              />
            </div>
            <p>
              Um Kartenansicht, Routen und Push-Benachrichtigungen auf einem anderen Gerät zu nutzen oder
              dauerhaft zu speichern, können Sie sich eine Profilnummer geben lassen.
            </p>
            <p>
              Mit dieser Profilnummer und Ihrem Passwort stellten Sie Ihr Nutzerprofil auf einem anderen Gerät, zum Beispiel einem Mobiltelefon, wieder her.
              Es werden hierfür keine persönlichen Daten von uns gespeichert.
            </p>
          </div>
          <SVGIcon
            @click.native.stop="tooltipOpen = true"
            name="fragezeichen_rot"
            class="cursor-pointer selfAlignCenter"
            size="little"
          />
        </div>

        <!-- Meinen Service anmelden -->
        <div
          v-if="!userToken && !checkIfErstellen()"
          class="displayflex padding10 cursor-pointer marginbottom20"
          style="justify-content:space-between"
          @click="setActiveProfilOption('ServiceAnmelden')"
        >
          <div class="displayflex">
            <SVGIcon name="user_on_kreis"/>
            <div class="colorBlue fontWeight600 selfAlignCenter marginleft15">Profil laden</div>
          </div>

          <div
            @click.stop
            v-if="tooltipOpen"
            class="backgroundGrey padding10 borderRadius10"
            style="position:absolute"
          >
            <div class="displayflex flexbetween">
              <SVGIcon name="id_transfer" size="big" style="width:100px"/>
              <SVGIcon
                name="close"
                size="small"
                class="cursor-pointer"
                @click.native="tooltipOpen = false"
              />
            </div>
            <p>
              Um Kartenansicht, Routen und Push-Benachrichtigungen auf einem anderen Gerät zu nutzen oder
              dauerhaft zu speichern, können Sie sich eine Profilnummer geben lassen.
            </p>
            <p>
              Mit dieser Profilnummer und Ihrem Passwort stellten Sie Ihr Nutzerprofil auf einem anderen Gerät, zum Beispiel einem Mobiltelefon, wieder her.
              Es werden hierfür keine persönlichen Daten von uns gespeichert.
            </p>
          </div>
          <!-- <div class="displayflex flexend"> -->
          <SVGIcon
            name="fragezeichen"
            class="cursor-pointer selfAlignCenter"
            size="little"
            @click.native.stop="tooltipOpen = true"
          />
          <!-- </div> -->
        </div>

        <!--
              #######
              Service angemeldet
              #######
        -->
        <!-- <div class="displayflex flexbetween colorDarkGrey marginbottom15 width95" v-if="userToken">
              <div class="displayflex">
                <SVGIcon name="user_grau" size="little" />
                <div class="selfAlignCenter marginleft15 fontsize16">Service angemeldet</div>
              </div>
              <SVGIcon name="thumb_up" size="little" />
        </div>-->
        <!--
              #######
              Service abmelden
              #######
        -->
        <div class="displayflex colorDarkGrey cursor-pointer marginbottom15" v-if="userToken">
          <!-- <div class="displayflex"> -->
          <SVGIcon name="user_grau" size="little"/>
          <div class="selfAlignCenter marginleft15 fontsize16 fontweight600">Profil angemeldet</div>
          <!-- </div> -->
          <!-- <SVGIcon
            @click.native.stop
            name="fragezeichen"
            class="cursor-pointer selfAlignCenter"
            size="little"
          />-->
        </div>

        <div
          class="displayflex colorBlue cursor-pointer marginbottom15"
          v-if="userToken"
          @click="$store.dispatch('serviceAbmelden')"
        >
          <SVGIcon name="minus" size="little"/>
          <div class="selfAlignCenter marginleft15 fontsize16">Profil abmelden</div>
        </div>

        <!--
            ######################
            Zusätzliche Optionen
            ######################
        -->
        <!-- <div
              class="profilAdditionalOptions fontsize16 marginbottom15"
              @click="setActiveProfilOption('Informationen')"
              v-if="userToken"
            >
              <SVGIcon name="info_neg" size="little" />
              <div class="marginleft15">Informationen</div>
            </div>

            <div
              class="profilAdditionalOptions fontsize16"
              @click="setActiveProfilOption('Datenschutz')"
              v-if="userToken"
            >
              <SVGIcon name="datenschutz" size="little"/>
              <div class="marginleft15">Hinweise zum Datenschutz</div>
        </div>-->
      </div>

      <!--
            ######################
            Zusätzliche Seiten zur Darstellung bei Klick auf Optionen
            ######################
      -->
      <MeinServiceAnmelden
        v-if="activeProfilOption === 'ServiceAnmelden'"
        @GoBackToProfil="setActiveProfilOption(null)"
      />
      <MeinServiceErstellen
        v-if="activeProfilOption === 'ServiceErstellen'"
        @GoBackToProfil="setActiveProfilOption(null)"
      />

      <NeueRoute
        v-if="activeProfilOption === 'NeueRoute'"
        @GoBackToProfil="setActiveProfilOption(null)"
        @closeSidebar="closeSidebar"
      />
    </div>
  </div>
</template>

<script>
import PushSettings from "../Profil/PushSettings.vue";
import MeineKarten from "../Profil/MeineKarten.vue";
import MeineStrecken from "../Profil/MeineStrecken.vue";
import NeueRoute from "../Profil/NeueRoute.vue";
import MeinServiceAnmelden from "../Profil/MeinServiceAnmelden.vue";
import MeinServiceErstellen from "../Profil/MeinServiceErstellen.vue";
import Header from "../CoreComponents/Header.vue";

export default {
  name: "Profil",
  components: {
    Header,
    PushSettings,
    MeineKarten,
    MeineStrecken,
    NeueRoute,
    MeinServiceAnmelden,
    MeinServiceErstellen
  },
  data: function() {
    return {
      tooltipOpen: false
    };
  },
  computed: {
    userToken() {
      return this.$store.state.userToken;
    },
    device() {
      return this.$store.state.device;
    },
    activeProfilOption() {
      return this.$store.state.activeProfilOption;
    },
    routen() {
      return this.$store.state.routen;
    },
    kartenansicht() {
      return this.$store.state.kartenansicht;
    }
  },
  methods: {
    closeSidebar() {
      this.$emit("close");
    },
    checkIfErstellen() {
      if (this.routen.length !== 0 || this.kartenansicht) return true;
      else return false;
    },
    setActiveProfilOption(setTo) {
      this.$store.commit("setActiveProfilOption", setTo);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.profilContainer {
  width: 100%;
  height: 100%;
}
.header {
  width: 100%;
  display: flex;
}
hr {
  border: 1px solid #90989c;
  border-radius: 5px;
  opacity: 0.5;
}
.close {
  width: calc(2 / 12 * 100%);
  padding-right: 15px;
  padding-left: 15px;
  text-align: right;
}

.profilContent {
  height: calc(100% - 62.4px);
  width: 95%;
  overflow-y: auto;
  font-size: 18px;
}

.profilAdditionalOptions {
  display: flex;
  justify-content: flex-start;
  cursor: pointer;
}
.profilAdditionalOptions .icon {
  margin-right: 10px;
}
</style>
